/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

class GlobalListeners {
    constructor() {
        this.selectors = {
            quickAdds: '[quick-add-qf]',
            productForm: `[action="${window.Shopify.routes.root}cart/add"]`,
        };
        
        this.init();
    }
    
    
    
    init() {
        document.body.addEventListener('click', this.handleEvent.bind(this));
    }
    
    handleEvent(e) {
        console.log('🔥 GlobalListeners handleEvent', e.target);
        // this.handleKlaviyoBackInStock(e);
        this.klaviyoBackInStockTrigger(e);
    }
    
    
    
    async klaviyoBackInStockTrigger(e) {
        const trigger = e.target.closest('[data-klaviyo-bis-trigger]');
        if (!trigger) return;
        const productPath = trigger.getAttribute('data-klaviyo-bis-trigger');
        if (!productPath) return;
        
        // Cancel previous fetch if ongoing
        if (this.klaviyoBackInStockTriggerController) {
            this.klaviyoBackInStockTriggerController.abort();
        }
        this.klaviyoBackInStockTriggerController = new AbortController();
        const controller = this.klaviyoBackInStockTriggerController;
        
        // Build URL using URL object to handle params correctly
        let url;
        try {
            url = new URL(productPath, window.location.origin);
            url.searchParams.set('section_id', 'hr-klaviyo-bis-modal');
        } catch (err) {
            console.error('Invalid productPath for Klaviyo Back In Stock:', productPath, err);
            return;
        }
        
        try {
            const response = await fetch(url.toString(), { signal: controller.signal });
            if (!response.ok) throw new Error('Network response was not ok');
            const html = await response.text();
            const temp = document.createElement('div');
            temp.innerHTML = html;
            // Remove any existing klaviyo-bis-modal elements
            document.querySelectorAll('klaviyo-bis-modal').forEach(el => el.remove());
            // Find the new modal in fetched HTML
            const modal = temp.querySelector('klaviyo-bis-modal');
            if (modal) {
                document.body.appendChild(modal);
            }
        } catch (err) {
            if (err.name === 'AbortError') {
                // Fetch was aborted, do nothing
            } else {
                console.error('Klaviyo Back In Stock Modal error:', err);
            }
        }
    }
    
    
    
}

window.GlobalListeners = new GlobalListeners();




class KlaviyoBackInStockModal extends HTMLElement {
    constructor() {
        super();
        
        this.selectors = {
            elements: {
                klaviyo_bis_modal: 'klaviyo-bis-modal'
            },
            classes: {
                modal: 'klaviyo-bis-modal__inner',
                close: 'klaviyo-bis-modal__close-button',
                klaviyo_form: {
                    form: 'klaviyo-bis-modal__form',
                    input: 'klaviyo-bis-modal__email-input', 
                    submit: 'klaviyo-bis-modal__submit-button',
                    notifyError: 'klaviyo-bis-modal__notify--error',
                    notifySuccess: 'klaviyo-bis-modal__notify--success'
                }, 
                states: {
                    open: 'klaviyo-bis-modal--open',
                    closed: 'klaviyo-bis-modal--closed',
                }
            }
        }
        
        this.translations = {
            sending: this.getAttribute('data-sending'), 
            success: this.getAttribute('data-success'),
            error: this.getAttribute('data-error'), 
            submit: this.getAttribute('data-submit'),
            unexpected_error: this.getAttribute('data-unexpected-error')
        };
        
        
        this.form = this.querySelector(`.${ this.selectors.classes.klaviyo_form.form }`);
        this.input = this.querySelector(`.${ this.selectors.classes.klaviyo_form.input }`);
        this.submitButton = this.querySelector(`.${ this.selectors.classes.klaviyo_form.submit }`);
        this.variantID = this.dataset.variantId ? this.dataset.variantId : null;
        this.productID = this.dataset.productId ? this.dataset.productId : null;
        this.key = this.dataset.klaviyoApiKey ? this.dataset.klaviyoApiKey : null;

        this.handleSubmitEvent = this.handleSubmitEvent.bind(this);
        this.handleClickEvent = this.handleClickEvent.bind(this);
    }
    
    
    static get observedAttributes() {
        return ['data-variant-id', 'data-product-id', 'data-klaviyo-api-key', 'aria-hidden'];
    }
    
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-variant-id') {
        this.variantID = newValue;
        } else if (name === 'data-product-id') {
        this.productID = newValue;
        } else if (name === 'data-klaviyo-api-key') {
        this.key = newValue;
        } else if (name === 'aria-hidden') {
        if (newValue === 'true') {
            this.classList.add(this.selectors.classes.states.closed);
            this.classList.remove(this.selectors.classes.states.open);
        } else {
            this.classList.remove(this.selectors.classes.states.closed);
            this.classList.add(this.selectors.classes.states.open);
        }
        }
    }
    
    
    connectedCallback() {
        this.init();
    }
    
    
    disconnectedCallback() {
        this.removeEventListener('submit', this.handleSubmitEvent);
        this.removeEventListener('click', this.handleClickEvent);
    }
    
    
    init() {
        this.addEventListener('submit', this.handleSubmitEvent);
        this.addEventListener('click', this.handleClickEvent);
        this.open();
    }
    
    
    open() {
        this.setAttribute('aria-hidden', 'true');
        
        // Force browser to calculate styles (flush layout)
        void this.offsetWidth;
        
        this.setAttribute('aria-hidden', 'false');
        this.classList.add(this.selectors.classes.states.open);
        this.input?.focus();
    }
    
    
    close() {
        this.setAttribute('aria-hidden', 'true');
        this.classList.remove(this.selectors.classes.states.open);
        
        const onTransitionEnd = (event) => {
            if (event.target === this) {
                this.classList.add(this.selectors.classes.states.closed);
                this.remove();
                this.removeEventListener('transitionend', onTransitionEnd);
            }
        };
        this.addEventListener('transitionend', onTransitionEnd);
    }
    
    
    handleClickEvent(e) {
        if (e.target.classList.contains(this.selectors.classes.close) || !e.target.closest(`.${this.selectors.classes.modal}`) ) {
            this.close();
        }
    }
    
    
    handleSubmitEvent(e) {
        e.preventDefault();
        const { valid, errors } = this.validate();
        if (!valid) {
            this.notify(errors);
            return;
        }
        this.submit();
    }
    
    
    validate() {
        this.clearErrors();
        const errors = [];
        if (!this.form || !this.input || !this.submitButton || !this.key || (!this.productID && !this.variantID)) {
            errors.push("Form is not properly configured.");
            return { valid: false, errors };
        }
        const email = this.input.value.trim();
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!isValidEmail) {
            errors.push("Please enter a valid email address.");
        }
        return { valid: errors.length === 0, errors };
    }
    
    
    clearErrors() {
        const errorNotifies = this.form.querySelectorAll(`.${this.selectors.classes.klaviyo_form.notifyError}`);
        errorNotifies.forEach(el => el.remove());
        if (this.input) {
            this.input.removeAttribute('aria-invalid');
        }
    }
    
    
    notify(messages, { type = 'error', container = this.form, replace = false } = {}) {
        if (!container || !messages || messages.length === 0) return;
        
        if (replace) {
            container.innerHTML = '';
        }
        
        const notifyContainer = document.createElement('div');
        notifyContainer.setAttribute('role', 'alert');
        if (type === 'error') {
            notifyContainer.classList.add(this.selectors.classes.klaviyo_form.notifyError);
        } else if (type === 'success') {
            notifyContainer.classList.add(this.selectors.classes.klaviyo_form.notifySuccess);
        }
        
        notifyContainer.innerHTML = messages.map(msg => `<div class="error-message">${msg}</div>`).join('');
        container.prepend(notifyContainer);
        
        if (type === 'error' && this.input) {
            this.input.setAttribute('aria-invalid', 'true');
        }
    }
    
    
    processing(state = true) {
        if (!this.submitButton) return;
        if (state) {
            this.submitButton.classList.add('disabled', 'processing');
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.textContent = this.translations.sending || "Sending...";
        } else {
            this.submitButton.classList.remove('disabled', 'processing');
            this.submitButton.removeAttribute('disabled');
            this.submitButton.textContent = this.translations.submit || "Notify Me";
        }
    }
    
    
    async submit() {
        this.processing(true);
        this.clearErrors();
        
        const email = this.input.value.trim();
        const klaviyoApiKey = this.key;
        const variantIdOrProductId = this.variantID || this.productID;
        
        const payload = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: email
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantIdOrProductId}`
                        }
                    }
                }
            }
        };
        
        const requestOptions = {
            method: 'POST',
            headers: {
                "revision": "2024-07-15",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(payload),
            redirect: 'follow'
        };
        
        if (typeof klaviyo !== 'undefined' && klaviyo && klaviyo.push) {
            klaviyo.push(['identify', {
                '$email' : email,
            }]);
            klaviyo.push(['track', 'Subscribed to Back In Stock', {
                '$email': email,
            }]);
        }
        
        try {
            const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoApiKey}`, requestOptions);
            let data;
            try {
                const text = await response.text();
                if (text && text.trim().length > 0) {
                    try {
                        data = JSON.parse(text);
                    } catch {
                        data = {};
                    }
                } else {
                    data = {};
                }
            } catch {
                data = {};
            }
            
            if (response.status === 202) {
                this.input.value = "";
                this.notify(
                    [ this.translations.success || "Thanks! We'll let you know when this item is back in stock." ],
                    { type: 'success', container: this.form, replace: true }
                );
            } else {
                this.notify([this.translations.error || "There was an error subscribing you to back in stock notifications. Please try again later."]);
            }
        } catch (error) {
            console.error(error);
            this.notify([this.translations.unexpected_error || "An unexpected error occurred. Please try again later."]);
        } finally {
            this.processing(false);
        }
    }
    
    
}
customElements.define("klaviyo-bis-modal", KlaviyoBackInStockModal);